import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Typography } from '@mui/material';

import { Context } from '../../context/DataContext';

const CheckPDFPage = () => {
  const navigate = useNavigate();
  const { state } = React.useContext(Context);
  const {
    customerInfo: {
      serviceName,
      payType,
      insuranceNo,
      fromDate,
      toDate,
      name,
      id,
      birthday,
      address,
      market_n,
      imei,
      phonePrice,
      phone,
      repairTarget,
      repairCount,
      swapPrice,
      insurancePrice,
      periodType,
    },
    loginInfo: { empName, empCode },
  } = state;
  const queryString = new URLSearchParams({
    service_name: serviceName,
    payment_type: payType,
    info_jstr: JSON.stringify({
      insurance_number: insuranceNo,
      period: `${fromDate} - ${toDate}`,
      name,
      id,
      birthday,
      address,
      model_name: market_n,
      imei,
      phone_price: phonePrice,
      phone,
      target: repairTarget,
      repair_count: repairCount,
      swap: swapPrice,
      price: insurancePrice,
      installment_price: payType === 'installment' ? insurancePrice : '',
      licenseNo: empCode,
      insuranceAgentName: empName,
      extraTerms:
        periodType === 'B' ? '安達產物行動裝置保險電池維修置換附加條款(D)' : '',
    }),
  }).toString();

  return (
    <Box>
      <Typography variant='h4' sx={{ my: 2 }}>
        要保書確認
      </Typography>
      <Box sx={{ position: 'relative' }}>
        <embed
          style={{
            height: 'calc(100vh - 234px)',
            width: '100%',
          }}
          src={`${process.env.REACT_APP_LEAGUE_BASE_WEB_URL}/m/insurance/consent/preview?${queryString}`}
        />
        <Button
          variant='contained'
          sx={{ width: 168, mt: 2 }}
          onClick={() => {
            navigate('/burglary-insur/client-sign');
          }}
        >
          下一步
        </Button>
      </Box>
    </Box>
  );
};

export default CheckPDFPage;
